import {Order} from "./order";
import {isDelivery} from "../misc/orders";
import Server from "../server";

export interface Saleable {
    name: string;
    sales: number;
    count: number;
    id?: string;
    numericId?: string;
}

export interface Product extends Saleable {
    addons: { [key: string] : number},
    totalSales: number;
}

export interface SalesData {
    products: Product[];
    addons: string[];
    total: Product;
}

export interface BestSellers {
    product: Product;
    cnt: number;
}

const DELIVERY = "Delivery";

const server = Server.instance();

export async function toSalesData(orders: Order[], expand: { [product: string] : boolean }) : Promise<SalesData> {

    const allProducts = await server.getProducts();

    const products : Product[] = [];

    const addonsMap : { [key: string] : boolean } = {};

    for (const order of orders) {

        const manual  = order.id && order.id.startsWith("manual-") ? true : false;
        const web  = order.id && order.id.startsWith("online-") ? true : false;
        const wix = ! web && ! manual;

        for (const lineItem of order.lineItems || []) {

            const quantity = Number(lineItem.quantity) || 1;

            const addons : { [key: string] : number} = {};

            let price = 0; // Product price
            let totalPrice = 0; // Product + extras + delivery price

            if (manual) {
                // Doesn't include extras
                price = totalPrice = Number(lineItem.price);
            }

            if (web) {
                // Does include extras
                price = totalPrice = Number(lineItem.price);
            }

            for (const option of lineItem.options || []) {
                const n = option.option as string;
                const v = option.selection as string;

                if (wix) {
                    const m = v.match(/\$([0-9]+(\.[0-9]+)?)/);
                    if (m) {
                        const p = m[1] as unknown as number;
                        const a = extractAddonName(n, v);
                        if (!a) {
                            price = Number(price) + Number(p * quantity);
                            totalPrice = Number(totalPrice) + Number(p * quantity);
                        } else {
                            addonsMap[a] = true;
                            addons[a] = p;
                            totalPrice = Number(totalPrice) + Number(p * quantity);
                        }
                    }
                }

                if (manual) {
                    const a = extractAddonName(n, v);
                    if (a) {
                        // @ts-ignore
                        const p = Number(option.price);
                        addonsMap[a] = true;
                        addons[a] = p;
                        totalPrice = Number(totalPrice) + Number(p * quantity);
                    }
                }

                if (web) {
                    const giftCategories = allProducts.filter(x => x.name == n);
                    if (giftCategories.length > 0 && giftCategories[0].productOptions && giftCategories[0].productOptions.length > 0) {
                        const gifts = (giftCategories[0].productOptions[0].choices || []).filter(x => x.description == v);
                        if (gifts.length > 0) {
                            const gift = gifts[0];
                            const p = Number(gift.value);
                            addonsMap[n] = true;
                            addons[n] = p;
                            price = Number(price) - Number(p);
                        }
                    }
                }
            }

            const delivery = isDelivery(order);
            if (delivery) {
                addonsMap[DELIVERY] = true;
                const p = 20;
                addons[DELIVERY] = p;
                totalPrice = Number(totalPrice) + Number(p);
            }

            const product = {
                name: lineItem.name as string,
                addons: addons,
                sales: price,
                totalSales: totalPrice,
                id: order.id,
                // @ts-ignore
                numericId: order.number as string,
                count: 1,
            };

            products.push(product);
        }
    }

    // Now collate products unless expand
    const prodMap : { [name: string] : Product } = {};
    const productsOut : Product[] = [];

    for (const product of products) {
        const n = product.name;
        if (expand[n]) {
            productsOut.push(product);
        } else {
            prodMap[n] = add(product, prodMap[n]);
        }
    }
    for (const n of Object.keys(prodMap).sort()) {
        productsOut.push(prodMap[n]);
    }

    let total : Product = {
        name: "",
        sales: 0,
        totalSales: 0,
        count: 0,
        addons: {}
    };
    for (const p of productsOut) {
        total = add(total, p);
    }
    total.name = "Total";

    const out : SalesData = {
        products: productsOut.sort((a, b) => a.name.localeCompare(b.name)),
        addons: Object.keys(addonsMap),
        total: total
    };

    return out;

    function extractAddonName(optionName: string, optionValue: string) : string | undefined {
        const n = optionName;
        if (! n.startsWith("Add ") && optionValue.indexOf("+$") == -1) {
            return undefined;
        }
        let a = n.replace(/^Add /, "").replace(/:$/, "");
        a = a.charAt(0).toUpperCase() + a.slice(1);
        return a;
    }

    function add(a: Product, b: Product | undefined) : Product {
        if (! b) {
            return a;
        }
        const addons: { [key: string] : number} = {};
        for (const x of Object.keys(a.addons))  {
            addons[x] = addons[x] ? Number(addons[x]) + Number(a.addons[x]) : a.addons[x];
        }
        for (const x of Object.keys(b.addons))  {
            addons[x] = addons[x] ? Number(addons[x]) + Number(b.addons[x]) : b.addons[x];
        }
        return {
            name: a.name == b.name ? a.name : "",
            addons: addons,
            sales: a.sales + b.sales,
            totalSales: a.totalSales + b.totalSales,
            count: a.count + b.count,
        };
    }
}

export function toBestSellers(data: SalesData) : BestSellers[] {
    return [];
}
